import { AxiosRequestConfig } from 'axios';
import { getToken, getOtpToken } from 'data-layer-cr/dist/authentication';

export default function injectAuthorization(
  config: AxiosRequestConfig,
): AxiosRequestConfig | Promise<AxiosRequestConfig> {
  // always prefer pre-existing user login. Default to OTP authorization otherwise.
  const bearer = getToken() || getOtpToken();

  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${bearer}`,
    },
  };
}
